<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            form: {
                partners: [],
                rules:[],
            },
            default_companies:[],
            default_users:[],
            companies:[],
            users:[],
            next_id:{rules:0,partners:0},
            edit_index:-1,
            type:0,
            send: false,
        }
    },
    methods: {
        closedModal() {
            this.form.partners = [];
            this.form.rules = [];
            this.catalogue.company_user = [];
            this.catalogue.rules_shares = [];
            this.companies=[];
            this.next_id={rules:0,partners:0};
            this.edit_index=-1;
            this.send = false;
            this.errors = {};
            this.$modal.hide('editRules');
        },
        async saveRules() {
            this.send = true;
            const data_form = new FormData();
            let _endpoint = '/partners/rules';

            if(this.type==0){
                const rulesArray = this.form.rules.map(p => ({
                    id: p.id,
                    name: p.name,
                    description: p.description,
                    type: p.type,
                    value: p.value || 0,
                }));

                data_form.append('rules', JSON.stringify(rulesArray));
            }else{
                const partnersArray = this.form.partners.map(p => ({
                    user_id: p.user_id,
                    company_id: p.company_id??p.company.id,
                    type: p.type,
                    value: p.value || 0,
                }));

                data_form.append('partners', JSON.stringify(partnersArray));
            }

            try {
                let { data } = await request.post(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    if(this.type==1){
                        this.catalogue.get_rules_partners();
                    }
                    // this.closedModal();
                }
                this.errors = {};
                this.send = false;
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },
		addRuleRow(table) {
            let vm=this;
            if(table=='rules'){
                this.form.rules.push({
                    id: vm.next_id,
                    name: '',
                    description: '',
                    type: 1,
                    value: 0,
                });
                this.next_id.rules++;
            }else{
                let vm=this;
                this.form.partners.push({
                    user_id: 0,
                    company_id: 0,
                    type: 1,
                    value: 0,
                    companies:vm.default_companies,
                    users:vm.default_users,
                    editable:true,
                });
                this.companies[this.next_id.partners]=
                this.next_id.partners++;
            }
        },
		removeRuleRow(index,table) {
            let tit = 'Eliminar Regla';
            let txt = 'Seguro que quiere eliminar lña regla';
            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.callDeleted(index,table);
                }
            });
		},
		async callDeleted(index,table) {
			if(table=='rules'){
				let _endpoint = 'shares/rules/' + this.form.rules[index].id;
				try {
					let response = await request.destroy(_endpoint).then(function (response) { return response; });
                    try{
                        this.form.rules.splice(index, 1);
                        this.form.rules.forEach((c, i) => c.id = i + 1);
                        this.next_id.rules--;
                    }catch(error){
                        console.error(error)
                    }
                    this.successNotification(response.data.message);
				} catch (error) {
					this.errors = await this.errorNotification(error)
				}
			}else{
				let _endpoint = 'shares/rules/' + this.form.partners[index].user_id + '/' + this.form.partners[index].company.id;
				try {
					let response = await request.destroy(_endpoint).then(function (response) { return response; });
                    console.log(JSON.stringify(response));
                    try{
                        this.form.partners.splice(index, 1);
                        this.form.partners.forEach((c, i) => c.id = i + 1);
                        this.next_id.partners--;
                    }catch(error){
                        console.error(error)
                    }
                    this.successNotification(response.data.message);
				} catch (error) {
					this.errors = await this.errorNotification(error)
				}
			}
		},
        async updateCompanies(obj) {
            await this.catalogue.get_companies_users(obj.user_id);
            obj.companies=this.catalogue.companies_users;
        },
        async updateUsers(obj) {
            await this.catalogue.get_company_user_partner(obj.company_id);
            obj.users=this.catalogue.company_user;
        },
        updateRules() {
            let vm=this;
            this.next_id.rules=0;
            this.form.rules=[];
            this.catalogue.rules_shares.forEach(function (valor) {
                vm.form.rules.push({
                    id: valor.id,
                    name: valor.name,
                    description: valor.description,
                    type: valor.type,
                    value: valor.type==1?Math.round(parseFloat(valor.value)*1000000)/10000:Math.round(parseFloat(valor.value)*100)/100,
                });
                vm.next_id.rules=Math.max(vm.next_id.rules,valor.id+1);
            });
        },
        async updatePartners() {
            let vm=this;
            this.next_id.partners=0;
            this.form.partners=[];
            this.catalogue.rules_partners.forEach(function(user){
                vm.form.partners.push({
                    user_id: user.user_id,
                    user: user.user,
                    company: user.company,
                    type: user.type,
                    value: user.type==1?Math.round((user.retention??0)*1000000)/10000:Math.round((user.retention??0)*100)/100,
                    editable:false,
                });
                vm.next_id.partners=Math.max(vm.next_id.partners,user.id+1);
            })
        },
        checkValue(object){
            if(object.type==1 && object.value>100){
                object.value=100;
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    watch: {
        'type'(value) {
            if(value==0){
                this.catalogue.get_rules_shares();
                this.form.partners=[];
            }else{
                this.catalogue.get_rules_partners();
                this.form.rules=[];
                this.catalogue.rules_shares=[];
            }
        },
        'catalogue.companies_users'() {
            if(this.catalogue.companies_users.length>0)
                this.default_companies=this.catalogue.companies_users;
        },
        'catalogue.companies_buildings'() {
            if(this.catalogue.companies_buildings.length>0)
                this.default_companies=this.catalogue.companies_buildings;
        },
        'catalogue.users_profile'() {
            if(this.catalogue.users_profile.length>0)
                this.default_users=this.catalogue.users_profile;
        },
        'catalogue.rules_shares'() {
            if(this.type==0)
                this.updateRules();
        },
        'catalogue.rules_partners'() {
            if(this.type==1)
                this.updatePartners();
        }
    },
    mounted() {
        if (this.authUser.organization_charts_id != 1) {
            this.catalogue.get_companies_users(this.authUser.id);
        } else {
            this.catalogue.get_companies_buildings();
        }
        this.catalogue.get_users_profile(8);
        this.default_users=this.catalogue.users_profile;
    },
    created() {
        Event.$on("event-show-editRules", async () => {
            if(this.type==0){
                this.catalogue.get_rules_shares();
            }else{
                this.catalogue.get_rules_partners();
            }
            this.$modal.show('editRules');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <modal name="editRules" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveRules" method="post">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Reglas de Reparto</h5>
            </div>
            <div class="modal-body">
				<div class="row">
					<div class="col-md-12">
						<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
							<li class="nav-item">
								<a class="nav-link active" @click="type = 0" data-toggle="pill" role="tab"
									aria-selected="true">Globales</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click="type=1" data-toggle="pill" role="tab"
									aria-selected="false">Por Usuario</a>
							</li>
						</ul>
					</div>
				</div>
                <div class="row" v-if="type==0">
                    <div class="col-12 mt-3">
                        <div class="d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">Repartos:</h5>
                        <button type="button" class="btn btn-sm btn-outline-info" @click="addRuleRow('rules')">
                            <i class="fa fa-plus"></i> Agregar
                        </button>
                        </div>
                        <hr class="mt-2">
                        <div class="table-responsive">
                            <table class="table table-bordered text-center text-sm">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Descripci&oacute;n</th>
                                        <th>Tipo</th>
                                        <th>Valor</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody v-if="form.rules">
                                    <tr v-for="(rule, index) in form.rules" :key="index">
                                        <td>
                                            <input type="text" :readonly="rule.id==1"
                                                class="form-control" v-model="rule.name"
                                                :id="'description-' + index">
                                                <div v-if="errors && errors['rule-'+rule.id+'-name']" class="text-danger">{{
                                                    errors['rule-'+rule.id+'-name'][0] }}
                                                </div>
                                        </td>
                                        <td>
                                            <input type="text" :readonly="rule.id==1"
                                                class="form-control" v-model="rule.description"
                                                :id="'description-' + index" maxlength="30">
                                                <div v-if="errors && errors['rule-'+rule.id+'-description']" class="text-danger">{{
                                                    errors['rule-'+rule.id+'-description'][0] }}
                                                </div>
                                        </td>
                                        <td>
                                            <div>
                                                <select type="text" :readonly="rule.id==1"
                                                    class="form-control" v-model="rule.type"
                                                    @change="checkValue(rule)"
                                                    :id="'type-' + rule.id">
                                                    <option value="1"> Porcentaje </option>
                                                    <option value="2"> Monto </option>
                                                </select>
                                            </div>
                                        </td>
                                        <td>
                                            <input type="number" :readonly="rule.id==1"
                                                class="form-control" v-model="rule.value"
                                                :id="'values-' + index" step="0.0001"
                                                @input="checkValue(rule)"
                                                v-if="rule.type==1">
                                            <money class="form-control" v-model="rule.value"
                                                :id="'values-' + index"
                                                v-else></money>
                                                <div v-if="errors && errors['rule-'+rule.id+'-value']" class="text-danger">{{
                                                    errors['rule-'+rule.id+'-value'][0] }}</div>
                                        </td>
                                        <td class="text-center">
                                            <button type="button" class="btn btn-sm btn-outline-danger" v-if="rule.id!=1"
                                                @click="removeRuleRow(index,'rules')">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td align="center" colspan="5">Sin resultados.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button :disabled="send" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
                <div class="row" v-if="type==1">
                    <div class="col-12 mt-3">
                        <div class="d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">Socios:</h5>
                            <button type="button" class="btn btn-sm btn-outline-info" @click="addRuleRow('partners')">
                                <i class="fa fa-plus"></i> Agregar
                            </button>
                        </div>
                        <hr class="mt-2">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Socio</th>
                                        <th>Empresa</th>
                                        <th>Tipo</th>
                                        <th>Valor</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(user, index_user) in form.partners" :key="index_user">
                                        <td>
                                            <div v-if="user.editable">
                                                <select type="text" class="form-control" v-model="user.user_id" @change="updateCompanies(user)">
                                                    <option v-for="(partner, index) in user.users" :value="partner.id" :key="index">
                                                        {{ partner.name }} {{ partner.last_name }}</option>
                                                </select>
                                                <div v-if="errors && errors['partner-'+user.company_id+'-'+user.user_id+'-user']" class="text-danger">{{
                                                    errors['partner-'+user.company_id+'-'+user.user_id+'-user'][0] }}
                                                </div>
                                            </div>
                                            <div v-else>
                                                {{ user.user.name }} {{ user.user.last_name }}
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="user.editable">
                                                <select type="text" class="form-control" v-model="user.company_id" @change="updateUsers(user)">
                                                    <option v-for="(company, index) in user.companies" :value="company.id" :key="index">
                                                        {{ company.name }}</option>
                                                </select>
                                                <div v-if="errors && errors['partner-'+user.company_id+'-'+user.user_id+'-company']" class="text-danger">{{
                                                    errors['partner-'+user.company_id+'-'+user.user_id+'-company'][0] }}
                                                </div>
                                            </div>
                                            <div v-else>
                                                {{ user.company.name }}
                                            </div>
                                        </td>
                                        <td>
                                            <select type="text" class="form-control" v-model="user.type"
                                                :id="'type-' + user.id">
                                                <option value="1"> Porcentaje </option>
                                                <option value="2"> Monto </option>
                                            </select>
                                            <div v-if="errors && errors['partner-'+user.company_id+'-'+user.user_id+'-type']" class="text-danger">{{
                                                errors['partner-'+user.company_id+'-'+user.user_id+'-type'][0] }}
                                            </div>
                                        </td>
                                        <td>
                                            <input type="number" @input="checkValue(user)"
                                                class="form-control" v-model="user.value"
                                                :id="'values-' + user.id" step="0.0001"
                                                v-if="user.type==1">
                                            <money class="form-control" v-model="user.value"
                                                :id="'values-' + user.id"
                                                v-else></money>
                                                <div v-if="errors && errors['partner-'+user.company_id+'-'+user.user_id+'-value']" class="text-danger">{{
                                                    errors['partner-'+user.company_id+'-'+user.user_id+'-value'][0] }}</div>
                                        </td>
                                        <td class="text-center">
                                            <button type="button" class="btn btn-sm btn-outline-danger"
                                                @click="removeRuleRow(index_user,'partners')">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="errors && errors.partners" class="text-danger">{{ errors.partners[0] }}</div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button :disabled="send" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.image-upload>input {
    display: none;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>